module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_8.2e8c0b8d.jpg";